import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import ViewPage from '../../../../Components/ViewPage'
import { TabelaInoculantes } from './components/tabela'
import { ContainerInoculantes } from './styled'
import { Drawer } from 'antd'
import ButtonCustom from '../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { FormularioInoculantes } from './components/formulario'
import { useGetInoculantes } from '../../../../services/recomendacao/inoculantes/GET'
import { useGetMicrorganismos } from '../../../../services/admMicrorganismos/GET'
import { api } from '../../../../services/api'
import { useGetMarca } from '../../../../services/fertilizante/GET'
import { errorAlert, successAlert } from '../../../../utils/alert'
import { v4 as uid } from 'uuid'
import {
  useDeletarInoculante,
  usePutRemoverMicrorganismos,
} from '../../../../services/recomendacao/inoculantes/DELETE'
import {
  usePostInoculantes,
  usePutInoculantes,
} from '../../../../services/recomendacao/inoculantes/POST'
import { useGetBioInsumos } from '../../../../services/recomendacao/bioInsumo/GET'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'

const CadastroInoculantes: React.FC = () => {
  //TABELA
  const [open, setOpen] = useState<boolean>(false)
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [filtradoAtivo, setFiltradoAtivo] = useState<boolean>(false)
  const [total1, setTotal1] = useState(null)
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [carregou, setCarregou] = useState(true)

  //FORMULARIO
  const [openGaveta, setOpenGaveta] = useState<boolean>(false)
  const [update, setUpdate] = useState<number>(null)
  const [updateDuplicar, setUpdateDuplicar] = useState<number>(null)
  const [tab_selecionar_atual, setTab_selecionar_atual] = useState<
    'Dados do inoculante' | 'Composição'
  >('Dados do inoculante')
  const [nome, setNome] = useState<string>('')
  const [fabricante, setFabricante] = useState<string>('')
  const [fabricante_id, setFabricante_id] = useState<number>(null)
  const [formulacao, setFormulacao] = useState<string>('')
  const [formulacao_id, setFormulacao_id] = useState<number>(null)
  const [tecnologia, setTecnologia] = useState<string>('')
  const [tecnologia_id, setTecnologia_id] = useState<number>(null)
  const [volume_dose, setVolume_dose] = useState<string>('')
  const [observacao, setObservacao] = useState<string>('')
  const [origem_selecionada, setOrigem_selecionada] = useState<string>('')
  const [origem_selecionada_id, setOrigem_selecionada_id] = useState<number>(null)
  const [tipo_biologicos_selecionadas, setTipo_biologicos_selecionadas] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [aplicacao_selecionadas, setAplicacao_selecionadas] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [tipo_biologicos_selecionadas_editar, setTipo_biologicos_selecionadas_editar] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [aplicacao_selecionadas_editar, setAplicacao_selecionadas_editar] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [dose_padrao, setDose_padrao] = useState<string>('')
  const [data_biologicos, setData_biologicos] = useState([])
  const [data_formulacao, setData_formulacao] = useState([])
  const [data_aplicacao, setData_aplicacao] = useState([])
  const [data_tecnologia, setData_tecnologia] = useState([])

  //COMPOSICAO
  const [cepa, setCepa] = useState<string>('')
  const [concentracao, setConcentracao] = useState<string>('')
  const [valor, setValor] = useState<string>('')
  const [expoente, setExponte] = useState<string>('')
  const [porcentagem, setPorcentagem] = useState<string>('')
  const [tipo_porcentagem, setTipo_Porcentagem] = useState<string>('')
  const [tipo_porcentagem_id, setTipo_Porcentagem_id] = useState<number>(null)
  const [updateConcentracao, setUpdateConcentracao] = useState<string>('')
  const [microrganismo, setMicrorganismo] = useState<string>('')
  const [microrganismo_id, setMicrorganismo_id] = useState<number>(null)
  const [densidade, setDensidade] = useState<string>('')
  const [composicao_adicionada, setComposicao_adicionada] = useState([])
  const [composicao_adicionada_backup, setComposicao_adicionada_backup] = useState([])
  const [confirmar_exclusao_composicao, setConfirmar_exclusao_composicao] = useState<boolean>(false)
  const [id_item_atual_composicao, setId_item_atual_composicao] = useState<number>(null)
  const [nome_item_atual_composicao, setNome_item_atual_composicao] = useState<string>('')
  const [fake_loading_composicao, setFake_loading_composicao] = useState<boolean>(false)
  const [editar_concentracao, setEditar_concentracao] = useState(null)
  const [loadingComposicao, setLoadingComposicao] = useState<boolean>(false)
  const [deuErroDeletar, setDeuErroDeletar] = useState<string>('')

  //API
  /*GET*/
  const { data_mircrorganismos, refetch_data_mircrorganismos } = useGetMicrorganismos(-1)
  const { carregando_bioInsumo, data_bioInsumo, refetch_data_bioInsumo } = useGetBioInsumos(
    pagination,
    page,
    buscarTabela,
    6
  )
  const { refetch_data_marca, data_marca } = useGetMarca()
  const tiposSistemaGeral = async () => {
    const response = await api.get(`/tipos-sistema?pagination=-1`)

    const filtro_biologico = response.data.itens.filter((item) => item?.cod_tipo_geral === 235)
    const filtro_formulacao = response.data.itens.filter((item) => item?.cod_tipo_geral === 247)
    const filtro_aplicacao = response.data.itens.filter((item) => item?.cod_tipo_geral === 252)
    const filtro_tecnologia = response.data.itens.filter((item) => item?.cod_tipo_geral === 257)

    setData_biologicos(filtro_biologico)
    setData_formulacao(filtro_formulacao)
    setData_aplicacao(filtro_aplicacao)
    setData_tecnologia(filtro_tecnologia)
  }

  /*POST - PUT*/
  const { carregando_salvar_inoculantes, mutate_inoculantes } = usePostInoculantes()
  const { carregando_edit_inoculantes, mutate_edit_inoculantes } = usePutInoculantes(update)

  /*DELTE*/
  const { carregando_remover_microrganismos, mutate_remover_microrganismos } =
    usePutRemoverMicrorganismos()
  const { mudate_deletar_inoculante } = useDeletarInoculante()

  function abrir() {
    setOpenGaveta(true)
  }

  function fechar() {
    setUpdate(null)
    setUpdateDuplicar(null)
    setOpenGaveta(false)
    setTab_selecionar_atual('Dados do inoculante')
    setNome('')
    setOrigem_selecionada('')
    setOrigem_selecionada_id(null)
    setFabricante('')
    setFabricante_id(null)
    setTipo_biologicos_selecionadas([])
    setFormulacao('')
    setFormulacao_id(null)
    setAplicacao_selecionadas([])
    setTecnologia('')
    setTecnologia_id(null)
    setVolume_dose('')
    setDose_padrao('')
    setObservacao('')
    setTipo_Porcentagem('')
    setTipo_Porcentagem_id(null)
    setPorcentagem('')
    setValor('')
    setExponte('')
    setCepa('')
    setMicrorganismo('')
    setMicrorganismo_id(null)
    setEditar_concentracao(null)
    setComposicao_adicionada([])
    refetch_data_bioInsumo()
  }

  function editar(cod) {
    setUpdate(cod)
    const filtrado = data_bioInsumo?.itens.filter((item) => item?.cod === cod)
    setNome(filtrado[0]?.nome)
    setOrigem_selecionada(filtrado[0]?.parametros_bioinsumo[0]?.origem_nome)
    setOrigem_selecionada_id(filtrado[0]?.parametros_bioinsumo[0]?.origem)
    setFabricante(filtrado[0]?.fabricante_nome)
    setFabricante_id(filtrado[0]?.cod_fabricante)
    const editBiologicos = filtrado[0]?.finalidades?.map((item) => {
      return {
        descr: item?.finalidade_nome,
        id: item?.cod_finalidade,
        key: item?.cod_finalidade,
      }
    })
    setTipo_biologicos_selecionadas_editar(editBiologicos)
    setTipo_biologicos_selecionadas(editBiologicos)
    setFormulacao(filtrado[0]?.parametros_bioinsumo[0]?.formulacao_nome)
    setFormulacao_id(filtrado[0]?.parametros_bioinsumo[0]?.formulacao)
    const editAplicacao = filtrado[0]?.aplicacoes_bioinsumo?.map((item) => {
      return {
        descr: item?.aplicacao_nome,
        id: item?.cod_aplicacao,
        key: item?.cod_aplicacao,
      }
    })
    setAplicacao_selecionadas_editar(editAplicacao)
    setAplicacao_selecionadas(editAplicacao)
    setTecnologia(filtrado[0]?.parametros_bioinsumo[0]?.tecnologia_nome)
    setTecnologia_id(filtrado[0]?.parametros_bioinsumo[0]?.tecnologia)
    setVolume_dose(
      filtrado[0]?.parametros_bioinsumo[0]?.volume_dose
        .replace('.', ',')
        ?.replace(/([,]\d{2})\d*/, '$1')
    )
    setDose_padrao(filtrado[0]?.parametros_bioinsumo[0]?.doses_por_hectare)
    setObservacao(filtrado[0]?.descricao)
    let composicao = []
    filtrado[0]?.biocomposicao.forEach((data) => {
      composicao = [
        ...composicao,
        {
          uid: uid(),
          cod: data?.cod,
          cod_microrganismo: data?.cod_microrganismo,
          microrganismo_nome: data?.microrganismo_nome,
          concentracao: data?.concentracao,
          porcentagem: String(data?.porcentagem).replace(',', '.'),
          tipo_porcentagem_nome: data?.tipo_porcentagem_nome,
          tipo_porcentagem: data?.tipo_porcentagem,
          densidade: data?.densidade?.replace('.', ',')?.replace(/([,]\d{2})\d*/, '$1'),
          cepa: data?.cepa,
        },
      ]
    })
    setComposicao_adicionada(composicao)
    setOpenGaveta(true)
  }

  function duplicar(cod) {
    setUpdateDuplicar(cod)
    const filtrado = data_bioInsumo?.itens.filter((item) => item?.cod === cod)
    setNome(filtrado[0]?.nome)
    setOrigem_selecionada(filtrado[0]?.parametros_bioinsumo[0]?.origem_nome)
    setOrigem_selecionada_id(filtrado[0]?.parametros_bioinsumo[0]?.origem)
    setFabricante(filtrado[0]?.fabricante_nome)
    setFabricante_id(filtrado[0]?.cod_fabricante)
    const editBiologicos = filtrado[0]?.finalidades?.map((item) => {
      return {
        descr: item?.finalidade_nome,
        id: item?.cod_finalidade,
        key: item?.cod_finalidade,
      }
    })
    setTipo_biologicos_selecionadas_editar(editBiologicos)
    setTipo_biologicos_selecionadas(editBiologicos)
    setFormulacao(filtrado[0]?.parametros_bioinsumo[0]?.formulacao_nome)
    setFormulacao_id(filtrado[0]?.parametros_bioinsumo[0]?.formulacao)
    const editAplicacao = filtrado[0]?.aplicacoes_bioinsumo?.map((item) => {
      return {
        descr: item?.aplicacao_nome,
        id: item?.cod_aplicacao,
        key: item?.cod_aplicacao,
      }
    })
    setAplicacao_selecionadas_editar(editAplicacao)
    setAplicacao_selecionadas(editAplicacao)
    setTecnologia(filtrado[0]?.parametros_bioinsumo[0]?.tecnologia_nome)
    setTecnologia_id(filtrado[0]?.parametros_bioinsumo[0]?.tecnologia)
    setVolume_dose(
      filtrado[0]?.parametros_bioinsumo[0]?.volume_dose
        .replace('.', ',')
        ?.replace(/([,]\d{2})\d*/, '$1')
    )
    setDose_padrao(filtrado[0]?.parametros_bioinsumo[0]?.doses_por_hectare)
    setObservacao(filtrado[0]?.descricao)
    let composicao = []
    filtrado[0]?.biocomposicao.forEach((data) => {
      composicao = [
        ...composicao,
        {
          uid: uid(),
          cod: data?.cod,
          cod_microrganismo: data?.cod_microrganismo,
          microrganismo_nome: data?.microrganismo_nome,
          concentracao: data?.concentracao,
          porcentagem: String(data?.porcentagem).replace(',', '.'),
          tipo_porcentagem: data?.tipo_porcentagem,
          tipo_porcentagem_nome: data?.tipo_porcentagem_nome,
          densidade: data?.densidade?.replace('.', ',')?.replace(/([,]\d{2})\d*/, '$1'),
          cepa: data?.cepa,
        },
      ]
    })
    setComposicao_adicionada(composicao)
    setOpenGaveta(true)
  }

  function salvarInoculantes() {
    const aplicacao = aplicacao_selecionadas?.map((item) => item.id)
    const aplicacao_remover = aplicacao_selecionadas_editar
      .filter((id) => !aplicacao.includes(id?.id))
      ?.map((item) => item.id)
    const biologicos = tipo_biologicos_selecionadas?.map((item) => item.id)
    const finalidades_remover = tipo_biologicos_selecionadas_editar
      .filter((id) => !biologicos.includes(id?.id))
      ?.map((item) => item.id)

    const microrganismosFormatados = composicao_adicionada.map((item) => {
      return {
        cod_microrganismo: item?.cod_microrganismo,
        concentracao: item?.concentracao,
        porcentagem: Number(String(item?.porcentagem).replace(',', '.')),
        tipo_porcentagem: item?.tipo_porcentagem,
        densidade: item?.densidade,
        cepa: item?.cepa,
      }
    })
    const microrganismosForamRemovidos = composicao_adicionada_backup
      .filter(
        (itemAntes) =>
          !microrganismosFormatados.some(
            (itemDepois) => itemDepois.cod_microrganismo === itemAntes.cod_microrganismo
          )
      )
      .map((item) => item?.cod_microrganismo)

    if (update <= 0 || updateDuplicar > 0) {
      mutate_inoculantes({
        nome: nome,
        descricao: observacao,
        cod_fabricante: fabricante_id,
        cod_categoria_produto: 6,
        origem: origem_selecionada_id,
        formulacao: formulacao_id,
        aplicacao: aplicacao_selecionadas.map((item) => item?.id),
        tecnologia: tecnologia_id,
        volume_dose: parseFloat(volume_dose.replace(',', '.')),
        doses_por_hectare: Number(dose_padrao),
        finalidades: tipo_biologicos_selecionadas.map((item) => item?.id),
        microrganismos: microrganismosFormatados,
        refetch: () => {
          fechar()
          refetch_data_bioInsumo()
        },
      })
    } else {
      mutate_edit_inoculantes({
        nome: nome,
        descricao: observacao,
        cod_fabricante: fabricante_id,
        cod_categoria_produto: 6,
        origem: origem_selecionada_id,
        formulacao: formulacao_id,
        aplicacao: aplicacao_selecionadas.map((item) => item?.id),
        tecnologia: tecnologia_id,
        volume_dose: parseFloat(volume_dose.replace(',', '.')),
        doses_por_hectare: Number(dose_padrao),
        finalidades: tipo_biologicos_selecionadas.map((item) => item?.id),
        finalidades_remover,
        aplicacao_remover,
        microrganismos: microrganismosFormatados,
        microrganismos_remover: microrganismosForamRemovidos,
        refetch: () => {
          fechar()
          refetch_data_bioInsumo()
        },
      })
    }
  }

  function adicionarComposicao() {
    const check = composicao_adicionada.find((data) => data.cod_microrganismo === microrganismo_id)

    if (check !== undefined) {
      errorAlert('Microrganismo já inserido!')
      return
    }
    if (
      microrganismo_id <= 0 ||
      concentracao === '' ||
      (microrganismo_id <= 0 && concentracao === '') ||
      tipo_porcentagem_id <= 0 ||
      porcentagem === '' ||
      valor === '' ||
      expoente === ''
    ) {
      return errorAlert('Erro, preencha os dados')
    }

    setComposicao_adicionada([
      ...composicao_adicionada,
      {
        uid: uid(),
        cod: null,
        cod_microrganismo: microrganismo_id,
        microrganismo_nome: microrganismo,
        concentracao: `${valor}x10^${expoente}`,
        porcentagem: Number(String(porcentagem).replace(',', '.')),
        tipo_porcentagem: tipo_porcentagem_id,
        tipo_porcentagem_nome: tipo_porcentagem,
        densidade: densidade,
        cepa: cepa,
      },
    ])
    setMicrorganismo('')
    setMicrorganismo_id(null)
    setConcentracao('')
    setCepa('')
    setPorcentagem('')
    setValor('')
    setExponte('')
    setDensidade('')
  }

  const editarComposicao = (
    uid,
    cod_microrganismo,
    microrganismo_nome,
    tipo_porcentagem,
    tipo_porcentagem_nome,
    porcentagem,
    concentracao,
    densidade,
    cepa
  ) => {
    setEditar_concentracao(uid)
    setMicrorganismo(microrganismo_nome)
    setMicrorganismo_id(cod_microrganismo)
    setDensidade(densidade)
    setCepa(cepa)
    setTipo_Porcentagem(tipo_porcentagem_nome)
    setTipo_Porcentagem_id(tipo_porcentagem)
    setPorcentagem(porcentagem)
    const numeros = concentracao.match(/\d+(\.\d+)?/g) // pega todos os números (inteiros ou decimais)
    setValor(numeros[0])
    setExponte(numeros[2])
    const dados = [...composicao_adicionada]
    dados.forEach((data) => {
      if (data.cod === uid) {
        data.editable = true
      } else {
        data.editable = false
      }
    })
    setComposicao_adicionada(dados)
  }

  function limparPosSalvar() {
    setValor('')
    setExponte('')
    setMicrorganismo('')
    setMicrorganismo_id(null)
    setPorcentagem('')
    setCepa('')
    setDensidade('')
    setEditar_concentracao(null)
  }

  const salvarComposicao = (cod) => {
    setLoadingComposicao(true)
    const dados = [...composicao_adicionada]
    dados.forEach((data) => {
      if (data.cod === cod) {
        data.cod_microrganismo = microrganismo_id
        data.microrganismo_nome = microrganismo
        data.concentracao = `${valor}x10^${expoente}`
        data.porcentagem = porcentagem
        data.tipo_porcentagem = tipo_porcentagem_id
          ; (data.densidade = densidade), (data.cepa = cepa)
      }
      data.editable = false
    })
    successAlert('Composicao salva!', 1000)
    setTimeout(() => {
      setComposicao_adicionada(dados)
      limparPosSalvar()
      setLoadingComposicao(false)
    }, 1100)
  }

  const mudarConcentracao = (concen, uid) => {
    const dados = [...composicao_adicionada]
    let temp = []
    dados.forEach((data) => {
      if (data.cod === uid) {
        data.concentracao = concen
        setUpdateConcentracao(concen)
      }
      temp = [...temp, data]

      return temp
    })

    setComposicao_adicionada(temp)
  }

  const remover_microrganismos = async (uid, cod = null, cod_microrganismo) => {
    setFake_loading_composicao(true)
    setLoadingComposicao(true)
    const dados = [...composicao_adicionada]
    setComposicao_adicionada_backup(dados)
    let filtro = []
    if (dados.length === 1) {
      errorAlert('É necessário ter pelo menos 2 microrganismo(s) na composição!', 5000)
      setTimeout(() => {
        setFake_loading_composicao(false)
        setLoadingComposicao(false)
      }, 600)
    } else {
      filtro = dados.filter((data) => data.cod_microrganismo !== cod_microrganismo)
      setTimeout(() => {
        setFake_loading_composicao(false)
        setLoadingComposicao(false)
      }, 600)
      return setComposicao_adicionada(filtro)
    }
  }

  function deletarInoculante(cod) {
    setFake_loading(true)

    mudate_deletar_inoculante({
      cod_inoculante: cod,
      refetch_deletar: () => {
        fechar()
        refetch_data_bioInsumo()
      },
    })
    setTimeout(() => {
      setFake_loading(false)
    }, 800)
  }

  function mascaraDecimal(data) {
    let area = data.replace(/\D/g, '')
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')

    setVolume_dose(area)
  }

  useEffect(() => {
    if (deuErroDeletar === 'erro') {
      setComposicao_adicionada(composicao_adicionada_backup)
      setTimeout(() => {
        setDeuErroDeletar('')
      }, 800)
    } else {
      setDeuErroDeletar('')
      setComposicao_adicionada_backup([])
    }
  }, [deuErroDeletar])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        setFiltradoAtivo(true)
        refetch_data_bioInsumo()
      }, 700)
    }

    if (carregou === false) {
      if (buscarTabela === '' || buscarTabela.length <= 0) {
        setTimeout(() => {
          refetch_data_bioInsumo()
          setFiltradoAtivo(false)
        }, 700)
      }
    }
  }, [buscarTabela])

  useEffect(() => {
    refetch_data_bioInsumo()
  }, [pagination])

  useEffect(() => {
    refetch_data_bioInsumo()
  }, [page])

  useEffect(() => {
    if (filtradoAtivo === false) {
      setTotal1(data_bioInsumo?.total)
    }
  }, [data_bioInsumo?.total])

  useEffect(() => {
    refetch_data_bioInsumo()
    refetch_data_mircrorganismos()
    tiposSistemaGeral()
    refetch_data_marca()
    setTimeout(() => {
      setCarregou(false)
    }, 700)
  }, [])

  return (
    <ContainerInoculantes>
      <ViewPage
        title='Cadastro inoculantes'
        onPermission={setPermissions}
        rotina={107}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
        newHide
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Inoculantes</TitleH1>
        </div>
        <TabelaInoculantes
          loading={carregando_bioInsumo}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          total={data_bioInsumo?.total}
          listar_inoculantes={data_bioInsumo?.itens}
          abrir={abrir}
          permissao={permissions}
          editarCadastro={editar}
          deletar={deletarInoculante}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          duplicar={duplicar}
          totalRef={total1}
          filtroAtivado={filtradoAtivo}
          setFiltroAtivado={setFiltradoAtivo}
        />
        <Drawer
          width={860}
          open={openGaveta}
          onClose={fechar}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          destroyOnClose
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={salvarInoculantes}
                loading={carregando_salvar_inoculantes || carregando_edit_inoculantes}
                disabled={carregando_salvar_inoculantes || carregando_edit_inoculantes}
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={fechar}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
        >
          <FormularioInoculantes
            update={update}
            nome={nome}
            setNome={setNome}
            formulacao={formulacao}
            setFormulacao={setFormulacao}
            setFormulacao_id={setFormulacao_id}
            fabricante={fabricante}
            setFabricante={setFabricante}
            setFabricante_id={setFabricante_id}
            tecnologia={tecnologia}
            setTecnologia={setTecnologia}
            setTecnologia_id={setTecnologia_id}
            volume_dose={volume_dose}
            mascaraDecimal={mascaraDecimal}
            observacao={observacao}
            setObservacao={setObservacao}
            tab_selecionar_atual={tab_selecionar_atual}
            setTab_selecionar_atual={setTab_selecionar_atual}
            origem_selecionada={origem_selecionada}
            setOrigem_selecionada={setOrigem_selecionada}
            setOrigem_selecionada_id={setOrigem_selecionada_id}
            tipo_biologico_selecionadas={tipo_biologicos_selecionadas}
            setTipo_biologico_selecionadas={setTipo_biologicos_selecionadas}
            tipo_aplicacao_selecionadas={aplicacao_selecionadas}
            setTipo_aplicacao_selecionadas={setAplicacao_selecionadas}
            microrganismo_selecionado={microrganismo}
            setMicrorganismo_selecionado={setMicrorganismo}
            setMicrorganismo_selecionado_id={setMicrorganismo_id}
            concentracao={concentracao}
            setConcentracao={setConcentracao}
            valor={valor}
            setValor={setValor}
            expoente={expoente}
            setExpoente={setExponte}
            cepa={cepa}
            setCepa={setCepa}
            dose_padrao={dose_padrao}
            setDose_padrao={setDose_padrao}
            data_biológicos={data_biologicos}
            data_formulação={data_formulacao}
            data_aplicação={data_aplicacao}
            data_tecnologia={data_tecnologia}
            data_microrganismos={data_mircrorganismos?.itens}
            data_fabricante={data_marca}
            composicao_adicionada={composicao_adicionada}
            adicionarComposicao={adicionarComposicao}
            editarComposicao={editarComposicao}
            salvarComposicao={salvarComposicao}
            mudarConcentracao={mudarConcentracao}
            remover_microrganismos={remover_microrganismos}
            confirmar_exclusao={confirmar_exclusao_composicao}
            setConfirmar_exclusao={setConfirmar_exclusao_composicao}
            id_item_atual={id_item_atual_composicao}
            setId_item_atual={setId_item_atual_composicao}
            setNome_item_atual={setNome_item_atual_composicao}
            fake_loading={fake_loading_composicao}
            porcentagem={porcentagem}
            setPorcentagem={setPorcentagem}
            tipo_porcentagem={tipo_porcentagem}
            setTipo_porcentagem={setTipo_Porcentagem}
            setTipo_porcentagem_id={setTipo_Porcentagem_id}
            editar_concentracao={editar_concentracao}
            loadingComposicao={loadingComposicao}
            densidade={densidade}
            setDensidade={setDensidade}
          />
        </Drawer>
      </ViewPage>
    </ContainerInoculantes>
  )
}

export default CadastroInoculantes
